module.exports = require("./teo-UG.js");